import { render, staticRenderFns } from "./filter-group.vue?vue&type=template&id=20cc6835&scoped=true"
import script from "./filter-group.vue?vue&type=script&lang=js"
export * from "./filter-group.vue?vue&type=script&lang=js"
import style0 from "./filter-group.vue?vue&type=style&index=0&id=20cc6835&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cc6835",
  null
  
)

export default component.exports